export default "__VITE_ASSET__DSRM2w4n__"